import $ from 'jquery';

export default class {
  constructor(el) {
    const self = this;
    self.$el = $(el);

    let videoActive = $('.popup-youtube-video-active', self.$el).val();
    let $applyLink = $('.apply-link', self.$el);
    let $collapseIcon = $('.collapse-popup', self.$el);
    let $closeIcon = $('.close-popup', self.$el);
    let cookieName = 'cookie-close-popup-youtube-video';
    let cookieReduceName = 'cookie-reduced-popup-youtube-video';
    let wrapId = 'youtube-video-popup-iframe';
    let youtubeVideo = null;

    $applyLink.click(function (e) {
        e.preventDefault();
        createCookie(cookieName, 1, 5);
        let linkTo = $(this).attr('href');
        window.location.href = linkTo;
    });
    $collapseIcon.click(function (e) {
        e.preventDefault();
        createCookie(cookieReduceName, 1, 5);
        self.$el.addClass('popup-overlay--reduce-corner');
        muteVideo();
    });
    $closeIcon.click(function (e) {
        e.preventDefault();
        createCookie(cookieName, 1, 5);
        self.$el.hide();
    });

    window.addEventListener('youtube_accepted', () => {
      let src = $("#" + wrapId).attr('data-src');
      $("#" + wrapId).attr('src', src);
      $("#" + wrapId).removeAttr('data-src');
      $("#" + wrapId).addClass('ready');
    })

    window.addEventListener('youtube_declined', () => {
      let src = $("#" + wrapId).attr('src');
      $("#" + wrapId).attr('data-src', src);
      $("#" + wrapId).removeAttr('src');
      $("#" + wrapId).removeClass('ready');
    })

    if (!readCookie(cookieName) && videoActive == 'yes') {
        let popupYTVideoTimer = setInterval(function () {
            if (window.apiYT != null) {
                clearInterval(popupYTVideoTimer);
                if (readCookie(cookieReduceName)) {
                    self.$el.addClass('popup-overlay--reduce-corner');
                }
                self.$el.show();

                youtubeVideo = new window.apiYT.Player(wrapId, {
                  events: {
                    'onReady': youtubeVideoOnPlayerReady,
                    'onStateChange': (ev) => {
                      youtubeVideo = ev.target;
                    },
                  },
                });
            }
        }, 1000);
    }

    function youtubeVideoOnPlayerReady()
    {
        if (readCookie(cookieReduceName)) {
            muteVideo();
        }
    }

    // Create cookie
    function createCookie(name, value, hours) {
        var expires;
        if (hours) {
            var date = new Date();
            date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
            expires = "; expires="+date.toGMTString();
        }
        else {
            expires = "";
        }
        document.cookie = name+"="+value+expires+"; path=/";

        stopVideo();
    }

    // Read cookie
    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }

        return 0;
    }

    function muteVideo()
    {
        if (youtubeVideo != null) {
            youtubeVideo.mute();
        }
    }

    function stopVideo()
    {
        if (youtubeVideo != null) {
          if (typeof youtubeVideo.stopVideo == 'function') {
            youtubeVideo.stopVideo();
          }
        }
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/PopupYoutubeVideo.js